module.exports = __webpack_public_path__ + "img/icon_tuse_232.58aa878c.png";